import { parseNhlEventPayload } from '@c360/shared';
import type { SportEvent } from '../../types/SportEventTypes';
import { makeBaseSportEvent } from '../shared';

/**
 * Parse an NHL SES event (or a custom event) into the normalized SportEvent shape.
 * The payload branching lives in @c360/shared (parseNhlEventPayload), so the
 * business-api MCP server files events the same way.
 *
 * Returns null when no NHL-shaped branch matches — that's the registry's
 * signal to try the next sport module.
 *
 * Internal type is `any` (via makeBaseSportEvent) to avoid fighting the
 * @c360/types Event.payload union; the return cast to SportEvent is the
 * only sanctioned boundary where the {type, data} shape gets normalized.
 */
export function parseNhlEvent(rawEvent: any): SportEvent | null {
  const payload = parseNhlEventPayload(rawEvent);
  if (!payload) return null;
  const base = makeBaseSportEvent(rawEvent);
  base.payload = payload;
  return base as SportEvent;
}
